<template>
    <div>
        <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            style="margin-bottom: 10px"
        >
            新增配置
        </el-button>
        <filter-box
            channel="yee"
            @reset="resetEvent"
            @search="searchEvent"
        ></filter-box>
        <div class="tableList">
            <!-- 表格部分 -->
            <el-table
                v-loading="tableLoading"
                :data="tableData"
                style="width: 100%"
                class="table-box"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: '#606266',
                }"
            >
                <el-table-column
                    prop="memberid"
                    label="用户ID"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    prop="parent_merchant_no"
                    label="父商户编号"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="merchant_no"
                    label="商户号"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="short_name"
                    label="商户简称"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="sub_wx_appid"
                    label="微信公众号/小程序APPID"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="split_type"
                    label="是否分账"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        {{ scope.row.split_type === "1" ? "分账" : "不分账" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="add_time"
                    label="添加时间"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        {{ new Date(scope.row.add_time * 1000).toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="finish_time"
                    label="完成时间"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        {{ scope.row.finish_time !== "0" ? new Date(scope.row.finish_time * 1000).toLocaleString() : "未完成" }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="editWechat(scope.row)"
                        >
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="page-box">
                <el-pagination
                    @current-change="fetchList"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <yee-dialog
            :visible.sync="dialogVisible"
            :actionType="dialogType"
            :config="currentRow"
            @refresh="refreshList"
        ></yee-dialog>
    </div>
</template>

<script>
import { getMerchantYeePayList } from "@/api/config";
import FilterBox from "./components/filterBox.vue";
import YeeDialog from "./components/yeeDialog.vue";

export default {
    components: {
        FilterBox,
        YeeDialog,
    },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            tableLoading: false,
            tableData: [],
            searchParams: {
                use_env: "3",
                member_id: "",
            },
            dialogVisible: false,
            dialogType: "add",
            currentRow: null,
        };
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        async fetchList() {
            let { page, pageSize } = this;
            let { use_env, member_id } = this.searchParams;
            let params = {
                page,
                page_size: pageSize,
                use_env,
                member_id,
            };
            this.tableLoading = true;
            const res = await getMerchantYeePayList(params);
            this.tableLoading = false;
            if (res.code != 200) return;
            let { list, total } = res.data;
            this.tableData = list || [];
            this.total = parseInt(total);
        },
        addEvent() {
            this.dialogVisible = true;
            this.dialogType = "add";
        },
        resetEvent(params) {
            this.searchParams = params;
        },
        searchEvent(params) {
            let { use_env, member_id } = params;
            if (!use_env && !member_id)
                return this.$message.error("请输入搜索条件");
            this.page = 1;
            this.searchParams = params;
            this.fetchList();
        },
        editWechat(val) {
            this.currentRow = val;
            this.dialogType = "edit";
            this.dialogVisible = true;
        },
        refreshList() {
            if (this.dialogType === "add") {
                this.page = 1;
                this.fetchList();
            } else {
                this.fetchList();
            }
        },
    },
};
</script>

<style lang="scss"></style>
